import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getProfile,
  removeProfileAvatar,
  updateProfile,
  uploadProfileAvatar,
} from "@/api/profile";
import type { Profile } from "@ceo-cmd/shared";
import type { ProfilePatch } from "@/types";

const PROFILE_KEY = ["profile"] as const;

export function useProfile() {
  return useQuery<Profile>({
    queryKey: PROFILE_KEY,
    queryFn: getProfile,
    staleTime: 60_000,
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: ProfilePatch) => updateProfile(patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: PROFILE_KEY }),
  });
}

export function useUploadProfileAvatar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dataUrl: string) => uploadProfileAvatar(dataUrl),
    onSuccess: (profile) => qc.setQueryData(PROFILE_KEY, profile),
  });
}

export function useRemoveProfileAvatar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: removeProfileAvatar,
    onSuccess: (profile) => qc.setQueryData(PROFILE_KEY, profile),
  });
}
